var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08362 9.83333C1.20667 10.0048 1.3696 10.1437 1.55835 10.238C1.74709 10.3324 1.95597 10.3794 2.16695 10.375C2.37793 10.3794 2.58681 10.3324 2.77556 10.238C2.9643 10.1437 3.12723 10.0048 3.25028 9.83333C3.37334 9.6619 3.53627 9.523 3.72501 9.42863C3.91376 9.33425 4.12264 9.28725 4.33362 9.29167C4.5446 9.28725 4.75348 9.33425 4.94222 9.42863C5.13097 9.523 5.2939 9.6619 5.41695 9.83333C5.54 10.0048 5.70294 10.1437 5.89168 10.238C6.08043 10.3324 6.28931 10.3794 6.50029 10.375C6.71126 10.3794 6.92014 10.3324 7.10889 10.238C7.29763 10.1437 7.46057 10.0048 7.58362 9.83333C7.70667 9.6619 7.8696 9.523 8.05835 9.42863C8.24709 9.33425 8.45597 9.28725 8.66695 9.29167C8.87793 9.28725 9.08681 9.33425 9.27556 9.42863C9.4643 9.523 9.62723 9.6619 9.75029 9.83333C9.87334 10.0048 10.0363 10.1437 10.225 10.238C10.4138 10.3324 10.6226 10.3794 10.8336 10.375C11.0446 10.3794 11.2535 10.3324 11.4422 10.238C11.631 10.1437 11.7939 10.0048 11.917 9.83333M2.16695 8.75L1.62528 6.04167H11.3753L10.292 8.20833M2.70862 6.04167V2.79167H7.04195L9.20862 6.04167M3.79195 2.79167V0.625H3.25028",
    stroke: "#2B6ED5",
    strokeWidth: 1.01961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.e836b3e5d80873f8d38c7f62b179d2ef.svg";
export { ForwardRef as ReactComponent };